import axios from 'axios';

// Instancia axios apuntando al backend de Azure (catálogos, lugares, etc.)
const azureApi = axios.create({
  baseURL: 'https://backcvbgtmdesa.azurewebsites.net',
});

azureApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Instancia axios apuntando al backend local (usa env var en producción)
const localApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

localApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// ── Endpoints ──────────────────────────────────────────────────────────────

/**
 * Obtiene el catálogo general de clases y tipos de servicio.
 * @param {number} codCompania - Código de la compañía (ej. 44)
 */
export const getCatalogo = (codCompania) =>
  azureApi.get(`/api/Catalogos/general?cod_compania=${codCompania}`);

/**
 * Obtiene solo las clases de servicio (tipos de incidente) del backend local.
 * @param {number} codCompania - Código de la compañía (ej. 44)
 */
export const getClaseServicio = (codCompania) =>
  localApi.get(`/incidentes/catalogo/clases?cod_compania=${codCompania}`);

/**
 * Obtiene solo los tipos de servicio del backend local.
 * @param {number} codCompania - Código de la compañía (ej. 44)
 */
export const getTipoServicio = (codCompania) =>
  localApi.get(`/incidentes/catalogo/tipos?cod_compania=${codCompania}`);

/**
 * Obtiene los municipios de un departamento.
 * @param {number} idDepartamento - ID del departamento (ej. 1302 para Jalapa)
 */
export const getMunicipios = (idDepartamento) =>
  azureApi.get(`/api/lugares/municipios?id=${idDepartamento}`);

export const getDepartamentos = () =>
  azureApi.get('/api/lugares/departamentos');

export const getListadoServiciosGeo = (codCompania, fechaIni, fechaFin, nombreSolicitante = '') =>
  localApi.post('/auth/servicios-geo', {
    Cod_Compania:       codCompania,
    Fecha_Ini:          fechaIni,
    Fecha_Fin:          fechaFin,
    Nombre_Solicitante: nombreSolicitante,
  });

export const getLugares = () =>
  azureApi.get('/api/lugares/todos');

export default azureApi;